import { ClientOptions } from 'src/common-services/types/client-types'
import { LocationsClient } from 'src/common-services/clients/alphamap/locations'
import { MobilityClient } from 'src/common-services/clients/alphamap/mobility'
import { ShapesClient } from 'src/common-services/clients/alphamap/shapes'
import { TilesClient } from 'src/common-services/clients/alphamap/tiles'
import { DemographicsClient } from 'src/common-services/clients/alphamap/demographics'
import { OwnershipClientPoc } from 'src/common-services/clients/alphamap/ownership-poc'
import { OwnershipClient } from 'src/common-services/clients/alphamap/ownership'
import { BrandsMobilityClient } from 'src/common-services/clients/alphamap/brands-mobility'
import { BrandsDemographicsClient } from 'src/common-services/clients/alphamap/brands-demographics'
import { SearchClient } from 'src/common-services/clients/alphamap/search'

export type AlphamapClient = {
  locations: LocationsClient
  mobility: MobilityClient
  brandsMobility: BrandsMobilityClient
  brandsDemographics: BrandsDemographicsClient
  shapes: ShapesClient
  tiles: TilesClient
  demographics: DemographicsClient
  ownershipPOC: OwnershipClientPoc
  ownership: OwnershipClient
  search: SearchClient
}

export function initializeAlphamap(options: ClientOptions): AlphamapClient {
  return {
    locations: new LocationsClient(options),
    mobility: new MobilityClient(options),
    brandsMobility: new BrandsMobilityClient(options),
    brandsDemographics: new BrandsDemographicsClient(options),
    shapes: new ShapesClient(options),
    tiles: new TilesClient(options),
    demographics: new DemographicsClient(options),
    ownershipPOC: new OwnershipClientPoc(options),
    ownership: new OwnershipClient(options),
    search: new SearchClient(options),
  }
}
